import classNames from 'classnames'
import { ICampaignAssets } from '@/types/generated-contentful'
import { useDetailsContext } from '../DetailsProvider'
import { ExpressInterestCard } from './ExpressInterestCard'

interface Props {
  campaignAssets: ICampaignAssets
  isEmbed?: boolean
}

export const StickyExpressInterestCard: React.FC<Props> = ({ campaignAssets, isEmbed = false }) => {
  const { tabs } = useDetailsContext()
  const tabLength = tabs?.length || 0

  return (
    <ExpressInterestCard
      ref={null}
      campaignAssets={campaignAssets}
      className={classNames('sticky rounded-2xl border border-gray-300 bg-white p-6', {
        'top-24': isEmbed && tabLength > 1,
        'top-40': !isEmbed && tabLength > 1,
        'top-12': isEmbed && tabLength <= 1,
        'top-28': !isEmbed && tabLength <= 1,
      })}
      theme="light"
      displayDescription
      isEmbed={isEmbed}
    />
  )
}
